// @ts-nocheck
import { create } from 'zustand';

const initial = {
  email: '',
  password: '',
  passwordConfirm: '',
  fullName: '',
  phone: '',
  websiteUrl: '',
  company: '',
  tosChecked: false,
  loading: false,
  error: '',
};

const useLoginStore = create(set => ({
  ...initial,
  setField: (name, value) => set({ [name]: value }),
  setLoading: loading => set({ loading }),
  setError: error => set({ error }),
  toggleTos: () => set(s => ({ tosChecked: !s.tosChecked })),
  reset: () => set({ ...initial }),
}));

export default useLoginStore;
